import { useState, useRef, useEffect } from 'react';
import ViewItems from '../ViewItems';
import Text from '../Text';
import InputField from '../CustomInput';
import ErrorText from '../ErrorText';
import { RowView } from '../../components';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { fontSizes } from '../../constants/constants';
import { cn } from '../../utils/utils';
import * as Flags from 'country-flag-icons/react/3x2';
import dynamicfunction from '../../utils/dynamicfunction';
import { useSelector } from 'react-redux';
import { getContentKeyAccToLang } from '../../utils/utils';
const CustomDropdown = ({
  label,
  labelColor,
  options,
  selectedValue,
  onSelect,
  className,
  valueClasses,
  menuClasses,
  children,
  getContentKey,
  width = 'w-full',
  valueKey,
  errorMessage,
  isRequired,
  isSymbol,
  isDisabled,
  placeholder,
  isSearch = false,
  isMulti = false,
  isPhoneNumber = false,
  labelDivClass,
  isLabelHeight = false,
}) => {
  const dropdownRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');

  const { isArabic, direction} = dynamicfunction();
  const { dashboardContent } = useSelector((state) => state.content);

  const getPlaceholderKey = (key, isColon = false) => {
    return getContentKeyAccToLang(dashboardContent, key, isArabic, isColon);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event?.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelect = (e, item) => {
    if (isMulti) {
      e.stopPropagation();

      const current = Array.isArray(selectedValue) ? selectedValue : [];
      const exists = current.some((v) => v?.[valueKey] === item?.[valueKey]);
      const newValue = exists
        ? current.filter((v) => v?.[valueKey] !== item?.[valueKey])
        : [...current, item];

      onSelect(newValue);
    } else {
      onSelect(item);
      setIsOpen(false);
    }
    setSearch('');
  };

  const filteredOptions = options?.filter((item) =>
    (getContentKey
      ? getContentKey(item?.key)
      : isSymbol
      ? `${item?.name} - ${item?.symbol ?? item?.code}`
      : item?.[valueKey] ?? item?.label ?? item?.name
    )
      ?.toString()
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const value = isMulti
    ? selectedValue?.map((item) => item?.[valueKey])?.join(', ')
    : selectedValue?.[valueKey];

  return (
    <ViewItems
      className={cn(
        'relative',
        width,
        className,
        isDisabled ? 'opacity-50' : ''
      )}
    >
      {label && (
        <div className={cn(labelDivClass ? labelDivClass : isLabelHeight ? 'md:h-9' : "h-6")} >
          <Text
            text={label}
            size={fontSizes.h14}
            color={errorMessage ? 'text-red-500' : labelColor}
            className={cn('leading-4', isLabelHeight && 'mb-1')}
            isRequired={isRequired}
            isTruncate={false}
          />
        </div>
      )}

      <div onClick={() => !isDisabled && setIsOpen(!isOpen)} ref={dropdownRef}>
        {children ? (
          <div>{children}</div>
        ) : isSearch && isOpen ? (
          <InputField
            value={search}
            placeholder={
              placeholder ? placeholder : getPlaceholderKey('search')
            }
            onChange={(e) => setSearch(e.target.value)}
            isRequired={false}
            props={{
              onClick: (e) => {
                e.stopPropagation();
                setIsOpen(true);
              },
            }}
          />
        ) : (
          <RowView
            className={cn(
              'px-3 h-[40px] border rounded-lg w-full cursor-pointer justify-between items-center',
              errorMessage ? 'border-red-600' : 'border-border',
              valueClasses
            )}
          >
            <Text
              text={
                value?.length > 0
                  ? value
                  : placeholder || getPlaceholderKey('select')
              }
              size={fontSizes.h14}
              color={value ? 'text-primary-dark' : 'text-primary-dark/40'}
            />
            <ReactSVG src={icons.downArrow} />
          </RowView>
        )}

        {isOpen && options?.length > 0 && (
          <div
          dir={direction}
            className={cn(
              'absolute top-16 left-0 right-0 z-10 flex flex-col mt-2 bg-white shadow-lg rounded-md border border-border max-h-64 overflow-y-auto',
              menuClasses
            )}
          >
            {(isSearch ? filteredOptions : options)?.map((item, index) => {
              const isChecked =
                isMulti &&
                selectedValue?.length > 0 &&
                selectedValue?.some(
                  (val) => val?.[valueKey] === item?.[valueKey]
                );

              const Flag = Flags[item?.code];

              return (
                <div
                  key={index}
                  className={cn(
                    'py-2 px-4 flex items-center gap-2 border-b border-border cursor-pointer',
                    isChecked && 'bg-primary/10'
                  )}
                  onClick={(e) => handleSelect(e, item)}
                >
                  {isPhoneNumber && (
                    <Flag title={item?.code} className='h-5 rounded-sm' />
                  )}
                  <Text
                    text={
                      getContentKey
                        ? getContentKey(item?.[valueKey])
                        : isSymbol
                        ? `${item?.name} - ${item?.symbol ?? item?.code}`
                        : item?.[valueKey]
                    }
                    size={fontSizes.h14}
                  />
                  {isPhoneNumber && (
                    <Text
                      text={`+${item?.phone}`}
                      size={fontSizes.h14}
                      color='text-gilver-gray'
                      className='block'
                      isTruncate={false}
                    />
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <ErrorText text={errorMessage} />
    </ViewItems>
  );
};

export default CustomDropdown;
